(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4b09"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4b09"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jey7f", function(module, exports) {

$parcel$export(module.exports, "getAllowedCookies", function () { return $d0a7903e4974b019$export$78bb765b962664de; });
$parcel$export(module.exports, "getCookieDomain", function () { return $d0a7903e4974b019$export$79fcbe1b192cd706; });
$parcel$export(module.exports, "default", function () { return $d0a7903e4974b019$export$2e2bcd8739ae039; });

var $bg4xJ = parcelRequire("bg4xJ");

var $kDmAn = parcelRequire("kDmAn");
const $d0a7903e4974b019$export$78bb765b962664de = (allowedCookies)=>{
    const cookiesArray = {};
    allowedCookies.forEach((item)=>{
        const cookieValue = $d0a7903e4974b019$var$cookieService.getItem(item);
        if (cookieValue) cookiesArray[item] = cookieValue;
    });
    return cookiesArray;
};
const $d0a7903e4974b019$export$79fcbe1b192cd706 = (domain)=>{
    const regex = new RegExp(`^(${(0, $kDmAn.LANGUAGE_SUBDOMAINS).join('|')})\\.`);
    return (domain || location.hostname).replace(regex, '');
};
const $d0a7903e4974b019$var$cookieService = {
    maximalCookieTTL: 90,
    setItem: (key, value, days = 365, domain = '', sameSite = 'Lax')=>{
        const currentDate = new Date();
        currentDate.setTime(+currentDate + days * 86400000);
        document.cookie = `${key}=${value}; path=/; domain=${$d0a7903e4974b019$export$79fcbe1b192cd706(domain)}; expires=${currentDate.toUTCString()}; SameSite=${sameSite}; Secure`;
    },
    getItem: (name)=>{
        if (!document.cookie) return null;
        const cookies = document.cookie.split('; ');
        const cookie = cookies.find((cookie)=>cookie.startsWith(`${name}=`));
        if (!cookie) return null;
        return cookie.substring(name.length + 1);
    },
    removeItem (key, domain) {
        if (document.cookie) {
            const zeroTime = new Date(0);
            document.cookie = `${key}=; expires=${zeroTime.toUTCString()}${domain ? `; domain=${domain}` : ''}; path=/`;
        }
    },
    extractParamsFromURL: ()=>{
        const params = new URLSearchParams(window.location.search);
        const vars = {};
        params.forEach((value, key)=>{
            vars[key] = value;
        });
        return vars;
    },
    setCookieByParamUrl (paramKey, cookieKey) {
        const urlParamsObject = (0, $bg4xJ.getParamsFromUrl)();
        if ((0, $bg4xJ.doesUrlContainParam)(paramKey, urlParamsObject)) $d0a7903e4974b019$var$cookieService.setItem(cookieKey, urlParamsObject[paramKey], $d0a7903e4974b019$var$cookieService.maximalCookieTTL);
    },
    setupCookiesFromURL: (allowedParams)=>{
        const paramsToStore = $d0a7903e4974b019$var$cookieService.extractParamsFromURL();
        for(const paramName in paramsToStore)if ((0, $bg4xJ.doesUrlContainParam)(paramName, paramsToStore) && allowedParams.includes(paramName)) {
            const cookieName = paramName === 'xchangerId' ? 'xchanger_id' : paramName;
            $d0a7903e4974b019$var$cookieService.setItem(cookieName, paramsToStore[paramName], $d0a7903e4974b019$var$cookieService.maximalCookieTTL);
        }
    },
    setupCookiesFromClient: ()=>{
        if ($d0a7903e4974b019$var$cookieService.getItem('ik_referrer')) // TODO: Check is this code relevant for us.
        $d0a7903e4974b019$var$cookieService.setItem('ik_referrer', document.referrer);
    }
};
var $d0a7903e4974b019$export$2e2bcd8739ae039 = $d0a7903e4974b019$var$cookieService;

});
parcelRegister("bg4xJ", function(module, exports) {

$parcel$export(module.exports, "isPanelUrl", function () { return $265222550428d748$export$20980cc1374e1b8c; });
$parcel$export(module.exports, "doesUrlContainParam", function () { return $265222550428d748$export$902ed42de98921ac; });
$parcel$export(module.exports, "getParamsFromUrl", function () { return $265222550428d748$export$9b6f748a4c74bb77; });
$parcel$export(module.exports, "removeUrlParams", function () { return $265222550428d748$export$4f9c066ec897736f; });
$parcel$export(module.exports, "renameQueryParam", function () { return $265222550428d748$export$e16de3bdbb617fe2; });
$parcel$export(module.exports, "decodeUrlParams", function () { return $265222550428d748$export$f002049d3814fdfc; });
$parcel$export(module.exports, "createUrlWithParams", function () { return $265222550428d748$export$a8593f22bf2d4f51; });

var $7iiIP = parcelRequire("7iiIP");

var $kDmAn = parcelRequire("kDmAn");
const $265222550428d748$export$20980cc1374e1b8c = (url)=>url.hostname.includes('klient.') || url.hostname.includes('panel.') || url.pathname.startsWith('/logowanie');
const $265222550428d748$export$902ed42de98921ac = (key, urlParamsObject)=>{
    urlParamsObject = urlParamsObject || $265222550428d748$export$9b6f748a4c74bb77();
    return !!urlParamsObject[key];
};
const $265222550428d748$export$9b6f748a4c74bb77 = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(urlParams.keys()).length > 0 ? Object.fromEntries(urlParams.entries()) : {};
};
const $265222550428d748$export$b8eaffbd63e11c5f = (key)=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(key) ? urlParams.get(key) : null;
};
const $265222550428d748$export$4f9c066ec897736f = (url, paramsToRemove)=>{
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;
    paramsToRemove.forEach((param)=>searchParams.delete(param));
    return urlObj.origin + urlObj.pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '') + urlObj.hash;
};
function $265222550428d748$export$e16de3bdbb617fe2(fromParam, toParam) {
    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;
    if (params.has(fromParam)) {
        const value = params.get(fromParam);
        params.delete(fromParam);
        params.set(toParam, value || '');
        const newUrl = `${currentUrl.pathname}?${params.toString()}${currentUrl.hash}`;
        window.history.replaceState({}, '', newUrl);
    }
}
const $265222550428d748$export$f002049d3814fdfc = (url)=>{
    try {
        const { search: search, hash: hash } = new URL(url);
        const searchParams = Object.fromEntries(new URLSearchParams(search).entries());
        const paramsString = hash.startsWith('#/?') ? hash.slice(2) : '';
        const encodedParams = paramsString ? new URLSearchParams(paramsString).get('data') : null;
        let decodedParams = {};
        if (encodedParams) {
            decodedParams = JSON.parse(decodeURIComponent(encodedParams));
            decodedParams = Array.isArray(decodedParams) ? Object.assign({}, ...decodedParams) : decodedParams;
        }
        return {
            ...searchParams,
            ...decodedParams
        };
    } catch (error) {
        console.error('Error decoding URL params:', error);
        return {};
    }
};
const $265222550428d748$export$a8593f22bf2d4f51 = (cookiesToParam, url)=>{
    const newUrl = new URL(url);
    const cookieParams = new URLSearchParams(Object.entries(cookiesToParam).map(([key, value])=>[
            key,
            String(value)
        ]));
    if (!$265222550428d748$export$20980cc1374e1b8c(newUrl)) {
        newUrl.search = cookieParams.toString();
        return newUrl.toString();
    }
    newUrl.searchParams.delete('lang');
    if (cookieParams.has('language')) {
        newUrl.searchParams.set('lang', cookieParams.get('language'));
        cookieParams.delete('language');
    } else newUrl.searchParams.set('lang', (0, $7iiIP.getCurrentLanguage)());
    const remainingParams = cookieParams.toString();
    if (remainingParams) {
        const hash = newUrl.hash || '#/';
        const separator = hash.includes('?') ? '&' : '?';
        newUrl.hash = `${hash}${separator}${remainingParams}`;
    } else if (!newUrl.hash) newUrl.hash = '#/';
    return newUrl.toString();
};
function $265222550428d748$export$304e24f68705812f(param, value) {
    if (param.type === 'boolean') try {
        return JSON.parse(value) === true || JSON.parse(value) === false;
    } catch (e) {
        return false;
    }
    if (param.type === 'string') {
        if (typeof value !== 'string' || value === 'true' || value === 'false') return false;
        if (param.name === 'lang' && param.allowedValues) {
            const allowedLanguages = Object.values((0, $kDmAn.SupportedLanguages));
            return allowedLanguages.includes(value);
        }
        return true;
    }
    return false;
}

});
parcelRegister("7iiIP", function(module, exports) {

$parcel$export(module.exports, "getLangFromUrl", function () { return $e808b7286267199c$export$5803c3c1cacc7a03; });
$parcel$export(module.exports, "getCurrentLanguage", function () { return $e808b7286267199c$export$604ba5624273df44; });

var $jey7f = parcelRequire("jey7f");

var $kDmAn = parcelRequire("kDmAn");

var $gXaPs = parcelRequire("gXaPs");
const $e808b7286267199c$var$isBrowser = typeof window !== 'undefined';
const $e808b7286267199c$export$e7bdde1845b77176 = ()=>{
    if (!$e808b7286267199c$var$isBrowser) return null;
    try {
        const cookieLang = (0, $jey7f.default)?.getItem('language');
        return (0, $kDmAn.isSupportedLanguage)(cookieLang) ? cookieLang : null;
    } catch (error) {
        console.error('Error getting language from cookie:', error);
        return null;
    }
};
const $e808b7286267199c$export$5803c3c1cacc7a03 = ()=>{
    if (!$e808b7286267199c$var$isBrowser) return null;
    const hostname = window.location.hostname;
    if (hostname.startsWith('en.')) return (0, $kDmAn.SupportedLanguages).en;
    if (hostname.startsWith('ru.')) return (0, $kDmAn.SupportedLanguages).ru;
    if (hostname.startsWith('ua.')) return (0, $kDmAn.SupportedLanguages).ua;
    return (0, $kDmAn.SupportedLanguages).pl;
};
const $e808b7286267199c$export$b45fa50bf92adae6 = ()=>{
    const langFromEnv = $gXaPs?.env?.LANGUAGE;
    if (!langFromEnv) return null;
    return (0, $kDmAn.isSupportedLanguage)(langFromEnv) ? langFromEnv : null;
};
const $e808b7286267199c$var$getInitialLanguage = ()=>$e808b7286267199c$export$e7bdde1845b77176() || $e808b7286267199c$export$5803c3c1cacc7a03();
function $e808b7286267199c$export$604ba5624273df44() {
    const detectedLang = !$e808b7286267199c$var$isBrowser ? $e808b7286267199c$export$b45fa50bf92adae6() : $e808b7286267199c$var$getInitialLanguage();
    if (detectedLang) return detectedLang;
    const source = !$e808b7286267199c$var$isBrowser ? 'server environment' : 'cookie or URL';
    console.warn(`[getCurrentLanguage] Could not get language from ${source}, using default language:`, (0, $kDmAn.DEFAULT_LANGUAGE));
    return 0, $kDmAn.DEFAULT_LANGUAGE;
}

});
parcelRegister("kDmAn", function(module, exports) {

$parcel$export(module.exports, "SupportedLanguages", function () { return $996c0b2716149a12$export$fcdd902bf6e4111a; });
$parcel$export(module.exports, "DEFAULT_LANGUAGE", function () { return $996c0b2716149a12$export$910b680d1eea6990; });
$parcel$export(module.exports, "LANGUAGE_SUBDOMAINS", function () { return $996c0b2716149a12$export$f09a0a51279e987d; });
$parcel$export(module.exports, "isSupportedLanguage", function () { return $996c0b2716149a12$export$47c66070d6d6cd6d; });
var $996c0b2716149a12$export$fcdd902bf6e4111a = /*#__PURE__*/ function(SupportedLanguages) {
    SupportedLanguages["pl"] = "pl";
    SupportedLanguages["en"] = "en";
    SupportedLanguages["ru"] = "ru";
    SupportedLanguages["ua"] = "ua";
    return SupportedLanguages;
}({});
const $996c0b2716149a12$export$910b680d1eea6990 = "pl";
const $996c0b2716149a12$export$f09a0a51279e987d = [
    "pl",
    "en",
    "ru",
    "ua"
];
const $996c0b2716149a12$export$47c66070d6d6cd6d = (lang)=>typeof lang === 'string' && Object.values($996c0b2716149a12$export$fcdd902bf6e4111a).includes(lang);

});

parcelRegister("gXaPs", function(module, exports) {
// shim for using process in browser
var $c57a8e741463be4d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c57a8e741463be4d$var$cachedSetTimeout;
var $c57a8e741463be4d$var$cachedClearTimeout;
function $c57a8e741463be4d$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $c57a8e741463be4d$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $c57a8e741463be4d$var$cachedSetTimeout = setTimeout;
        else $c57a8e741463be4d$var$cachedSetTimeout = $c57a8e741463be4d$var$defaultSetTimout;
    } catch (e) {
        $c57a8e741463be4d$var$cachedSetTimeout = $c57a8e741463be4d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $c57a8e741463be4d$var$cachedClearTimeout = clearTimeout;
        else $c57a8e741463be4d$var$cachedClearTimeout = $c57a8e741463be4d$var$defaultClearTimeout;
    } catch (e) {
        $c57a8e741463be4d$var$cachedClearTimeout = $c57a8e741463be4d$var$defaultClearTimeout;
    }
})();
function $c57a8e741463be4d$var$runTimeout(fun) {
    if ($c57a8e741463be4d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c57a8e741463be4d$var$cachedSetTimeout === $c57a8e741463be4d$var$defaultSetTimout || !$c57a8e741463be4d$var$cachedSetTimeout) && setTimeout) {
        $c57a8e741463be4d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c57a8e741463be4d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c57a8e741463be4d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c57a8e741463be4d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c57a8e741463be4d$var$runClearTimeout(marker) {
    if ($c57a8e741463be4d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c57a8e741463be4d$var$cachedClearTimeout === $c57a8e741463be4d$var$defaultClearTimeout || !$c57a8e741463be4d$var$cachedClearTimeout) && clearTimeout) {
        $c57a8e741463be4d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c57a8e741463be4d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c57a8e741463be4d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c57a8e741463be4d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c57a8e741463be4d$var$queue = [];
var $c57a8e741463be4d$var$draining = false;
var $c57a8e741463be4d$var$currentQueue;
var $c57a8e741463be4d$var$queueIndex = -1;
function $c57a8e741463be4d$var$cleanUpNextTick() {
    if (!$c57a8e741463be4d$var$draining || !$c57a8e741463be4d$var$currentQueue) return;
    $c57a8e741463be4d$var$draining = false;
    if ($c57a8e741463be4d$var$currentQueue.length) $c57a8e741463be4d$var$queue = $c57a8e741463be4d$var$currentQueue.concat($c57a8e741463be4d$var$queue);
    else $c57a8e741463be4d$var$queueIndex = -1;
    if ($c57a8e741463be4d$var$queue.length) $c57a8e741463be4d$var$drainQueue();
}
function $c57a8e741463be4d$var$drainQueue() {
    if ($c57a8e741463be4d$var$draining) return;
    var timeout = $c57a8e741463be4d$var$runTimeout($c57a8e741463be4d$var$cleanUpNextTick);
    $c57a8e741463be4d$var$draining = true;
    var len = $c57a8e741463be4d$var$queue.length;
    while(len){
        $c57a8e741463be4d$var$currentQueue = $c57a8e741463be4d$var$queue;
        $c57a8e741463be4d$var$queue = [];
        while(++$c57a8e741463be4d$var$queueIndex < len)if ($c57a8e741463be4d$var$currentQueue) $c57a8e741463be4d$var$currentQueue[$c57a8e741463be4d$var$queueIndex].run();
        $c57a8e741463be4d$var$queueIndex = -1;
        len = $c57a8e741463be4d$var$queue.length;
    }
    $c57a8e741463be4d$var$currentQueue = null;
    $c57a8e741463be4d$var$draining = false;
    $c57a8e741463be4d$var$runClearTimeout(timeout);
}
$c57a8e741463be4d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c57a8e741463be4d$var$queue.push(new $c57a8e741463be4d$var$Item(fun, args));
    if ($c57a8e741463be4d$var$queue.length === 1 && !$c57a8e741463be4d$var$draining) $c57a8e741463be4d$var$runTimeout($c57a8e741463be4d$var$drainQueue);
};
// v8 likes predictible objects
function $c57a8e741463be4d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c57a8e741463be4d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c57a8e741463be4d$var$process.title = 'browser';
$c57a8e741463be4d$var$process.browser = true;
$c57a8e741463be4d$var$process.env = {};
$c57a8e741463be4d$var$process.argv = [];
$c57a8e741463be4d$var$process.version = ''; // empty string to avoid regexp issues
$c57a8e741463be4d$var$process.versions = {};
function $c57a8e741463be4d$var$noop() {}
$c57a8e741463be4d$var$process.on = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.addListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.once = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.off = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.removeListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.removeAllListeners = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.emit = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.prependListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.prependOnceListener = $c57a8e741463be4d$var$noop;
$c57a8e741463be4d$var$process.listeners = function(name) {
    return [];
};
$c57a8e741463be4d$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$c57a8e741463be4d$var$process.cwd = function() {
    return '/';
};
$c57a8e741463be4d$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$c57a8e741463be4d$var$process.umask = function() {
    return 0;
};

});





var $jey7f = parcelRequire("jey7f");
const $5dc8bdab168f3f17$var$getUtmzParams = ()=>{
    const params = {};
    const utmz = (0, $jey7f.default).getItem('__utmz');
    if (utmz) {
        const pairs = utmz.split('.').slice(4).join('.').split('|');
        for (const iterator of pairs){
            const temp = iterator.split('=');
            params[temp[0]] = temp[1];
        }
    }
    return params;
};
const $5dc8bdab168f3f17$var$isUserFromAdWords = (utmzParams)=>!!utmzParams?.utmgclid;
const $5dc8bdab168f3f17$var$isUserFromDirect = (utmzParams)=>!!utmzParams?.utmcsr && utmzParams.utmcsr === '(direct)';
const $5dc8bdab168f3f17$var$getCurrentSource = ()=>{
    let source = {
        date: new Date().toJSON()
    };
    const utmzParams = $5dc8bdab168f3f17$var$getUtmzParams();
    if (Object.keys(utmzParams).length) // other
    source = {
        ...source,
        other: true
    };
    else if ($5dc8bdab168f3f17$var$isUserFromAdWords(utmzParams)) // adwords
    source = {
        ...source,
        adwords: true
    };
    else if ($5dc8bdab168f3f17$var$isUserFromDirect(utmzParams)) // direct
    source = {
        ...source,
        direct: true
    };
    else {
        // campaign
        for(const paramName in utmzParams)if (Object.prototype.hasOwnProperty.call(utmzParams, paramName)) source[paramName] = utmzParams[paramName];
    }
    return source;
};
const $5dc8bdab168f3f17$var$trackSources = ()=>{
    /**
   * In oryginal code source there was if statment that do not track source from:
   * 1. User that is logged in
   * 2. User that come from panel to LP
   * 3. User has cookie 'registered'
   */ const sourcesText = (0, $jey7f.default).getItem('sources') || '[]';
    let sources = JSON.parse(sourcesText);
    sources.push($5dc8bdab168f3f17$var$getCurrentSource());
    if (sources.length > 5) sources = sources.slice(-5);
    (0, $jey7f.default).setItem('sources', JSON.stringify(sources), (0, $jey7f.default).maximalCookieTTL);
};
const $5dc8bdab168f3f17$var$setupCookies = ()=>{
    $5dc8bdab168f3f17$var$trackSources();
};
$5dc8bdab168f3f17$var$setupCookies();

})();
//# sourceMappingURL=statistics-cookies.js.map
